.rich-text-container {
    height: 100%;
}

.rich-text-container a:focus-visible {
    text-decoration: underline;
    outline: 2px solid var(--focus-blue);
    outline-offset: 2px;
}

.rich-text-container ul {
    list-style-type: disc;
    padding-left: 1.5em;
    height: 100%;
    word-break: break-word;
}

.rich-text-container a {
    color: var(--blue);
    text-decoration: underline;
}

.rich-text-container a:hover {
    color: var(--blue-dk);
}

.normal-font {
    font-size: var(--font-normal);
    line-height: 21.3px; /* matches line height of quill editor */
    color: var(--black);
}

.small-font {
    font-size: var(--font-small);
    line-height: 21.3px; /* matches line height of quill editor */
    color: var(--black);
}

.mini-font {
    font-size: 11px;
    line-height: 14px;
    color: var(--black);
}

.center-text {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.placeholder-text {
    color: var(--placeholder);
    cursor: default;
}

.small-line-height {
    line-height: 1.2em;
}

.light-color {
    color: var(--grey-lt);
}

.medium-color {
    color: var(--grey);
}

.truncate {
    width: 100%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

.truncate-inline {
    max-width: 100%;
    display: inline-block;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    vertical-align: bottom;
}

.max-lines {
    overflow: hidden;
}

.break-words {
    word-break: break-word;
}

.width-fit-content {
    width: fit-content;
}
